import { PropTypes } from 'prop-types';

const Months = (name) => {
  switch (true) {
    case (name === "January"):
      return 1;
    case (name === "February"):
      return 2;
    case (name === "March"):
      return 3;
    case (name === "April"):
      return 4;
    case (name === "May"):
      return 5;
    case (name === "June"):
      return 6;
    case (name === "July"):
      return 7;
    case (name === "August"):
      return 8;
    case (name === "September"):
      return 9;
    case (name === "October"):
      return 10;
    case (name === "November"):
      return 11;
    case (name === "December"):
      return 12;
    default:
      return name;
  }
};

Months.propTypes = {
  name: PropTypes.string
}

export default Months;
